import { render, staticRenderFns } from "./IconCart.vue?vue&type=template&id=6e04d692&lang=pug&"
import script from "./IconCart.vue?vue&type=script&lang=js&"
export * from "./IconCart.vue?vue&type=script&lang=js&"
import style0 from "./IconCart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e04d692')) {
      api.createRecord('6e04d692', component.options)
    } else {
      api.reload('6e04d692', component.options)
    }
    module.hot.accept("./IconCart.vue?vue&type=template&id=6e04d692&lang=pug&", function () {
      api.rerender('6e04d692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/icons/IconCart.vue"
export default component.exports